import React from 'react';

import CheckCircleIcon from '@/assets/images/level-detail/skill-detail/check-circle.png';
import { Stack } from '@/components/layout';
import { Image } from '@/components/ui';
import type { GuardianPlayerLevelDetailPin } from '@/features/guardian-player/types';
import { createStyles, useScaling } from '@/hooks';

type LevelDetailPinBadgeProps = {
  pin?: Pick<GuardianPlayerLevelDetailPin, 'pinImageUrl'>;
  pinImageUrl?: string | null;
  showCompletedBadge?: boolean;
  size: number;
};

export function LevelDetailPinBadge({
  pin,
  pinImageUrl,
  showCompletedBadge = false,
  size,
}: LevelDetailPinBadgeProps) {
  const styles = useStyles();
  const { scale } = useScaling();
  const imageUrl = pinImageUrl ?? pin?.pinImageUrl;
  const completedBadgeSize = scale(35);

  if (!imageUrl) return null;

  return (
    <Stack width={size} height={size} style={styles.container}>
      <Image
        source={{ uri: imageUrl }}
        width={size}
        height={size}
        resizeMode="contain"
        persistLoadedUri
        style={styles.pinImage}
      />
      {showCompletedBadge ? (
        <Stack
          align="center"
          justify="center"
          width={completedBadgeSize}
          height={completedBadgeSize}
          style={styles.completedBadge}>
          <Image
            source={CheckCircleIcon}
            width={completedBadgeSize}
            height={completedBadgeSize}
            resizeMode="contain"
          />
        </Stack>
      ) : null}
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  container: {
    position: 'relative',
  },
  pinImage: {
    borderRadius: scale(999),
    overflow: 'hidden',
  },
  completedBadge: {
    position: 'absolute',
    right: scale(-3),
    bottom: scale(-7),
    borderRadius: scale(999),
  },
}));
